import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import api from "../../http/index";
import { asyncSelector, asyncSelectorFailure, asyncSelectorSuccess } from "Redux/DataSlice/DataSlice";
import { toast } from "react-toastify";

const useDataFetch = (endpoint, dataName) => {
    const dispatch = useDispatch();

    const dataState = useSelector((state) => state.dataSlice[dataName]);

    const [loading, setLoading] = useState(dataState?.loading || false);
    const [error, setError] = useState(dataState?.error || null);
    const [data, setData] = useState(dataState?.data || null);

    useEffect(() => {

        const fetchData = async () => {
            if (dataState?.data || dataState?.loading) return;

            try {
                setLoading(true);
                dispatch(asyncSelector({ endpoint: dataName }));

                const response = await api.get(endpoint);
                const data = response.data.dataModel;
                dispatch(asyncSelectorSuccess({ endpoint: dataName, data }));

                setData(data);
                setLoading(false);
            } catch (err) {
                dispatch(asyncSelectorFailure({ endpoint: dataName, error: err.message }));
                setError(err.message);
                toast.error(`Data fetching failed for dropDown : ${dataName}`)
                setLoading(false);
            }
        };

        if (!dataState?.data && !loading) {
            fetchData();
        }
    }, [endpoint, dispatch, dataState, loading]);

    return { data, loading, error };
};

export default useDataFetch;
